import App from './App';
import UnauthApp from './UnauthApp';

declare global {
  interface Window {
    // Bootstrapped server-side by server.js's `data.app` (see the
    // window.App=... script tag in Html.tsx). `any` here means TypeScript
    // won't catch a typo'd field, so keeping a note of what server.js sends
    // is the next-best thing until this gets a real type:
    // ...traceSampleRatio: number, sentrySampleRatio: number (read from SSM otel_{trace,sentry}_sample_ratio, test_-prefixed off
    // production, default 0).
    App: any;
    createAccountData_email: string;
    dataLayer?: Record<string, unknown>[];
  }
}

export default App;

export { UnauthApp };
